(function () {
  'use strict';
  const controls = document.querySelector('[data-paint-controls]');
  const canvas = document.querySelector('[data-paint-canvas]');
  const playground = document.querySelector('[data-paint-playground]');
  if (!controls || !canvas || !playground || !window.NyeFluid) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggle = controls.querySelector('.nye-paint-toggle');
  const panel = document.getElementById('NyePaintPanel');
  const status = controls.querySelector('[data-paint-status]');
  const mascot = document.querySelector('[data-paint-mascot]');
  const spriteCanvas = mascot.querySelector('canvas');
  const spriteCtx = spriteCanvas.getContext('2d');
  const bubble = mascot.querySelector('[data-mascot-bubble]');
  const palettes = [
    {color:'#c680ad', name:"I'LL BE FINE."},
    {color:'#b8cc73', name:'TRUST NOBODY.'},
    {color:'#9387bf', name:'BAD TIMELINE.'}
  ];
  const ink = ['#a441b9','#bb4dcd','#abe043','#b72a30','#aac740','#af2b6b','#9dde45'];
  const tips = [[96,720],[213,696],[421,656],[571,704],[795,687],[919,708],[1089,691]];
  let width = 0, height = 0, pageHeight = 0, pixelRatio = 1;
  const raft = window.NyeRaft ? new window.NyeRaft() : null;
  const rider = window.NyeRaft?.Rider ? new window.NyeRaft.Rider() : null;
  const shake = window.NyeRaft?.ShakeDetector ? new window.NyeRaft.ShakeDetector() : null;
  let tiltFluid = null;
  let motionOn = false, motionWaiting = false, motionTimer = 0, lastMotion = 0;
  const gravity = {x:0,y:1}, targetGravity = {x:0,y:1};
  const motionButton = controls.querySelector('[data-paint-action="motion"]');
  let fluid, drops = [], splashes = [], streaks = [], sources = [], raf = 0, last = 0;
  let paused = reduced.matches, flooding = false, draining = false, colorIndex = 0;
  let plugOpen=false,plugLift=0;
  const plugHandle=document.querySelector('[data-paint-plug]');
  const plugArt=new Image();plugArt.onload=()=>{if(fluid)draw();};plugArt.src=canvas.dataset.drainArt||'';
  let floodTimer = 0, spriteVisible = false, spriteAge = 0, spriteReaction = 0, spriteFrame = -1;
  const sprite = new Image();
  const raftArt=new Image();raftArt.onload=()=>{if(fluid)draw();};raftArt.src=canvas.dataset.raftArt||'';
  const weather = window.NyeWeather ? new window.NyeWeather() : null;
  const weatherSelect = controls.querySelector('[data-paint-weather]');
  if(weather){weather.art=new Image();weather.art.src=canvas.dataset.umbrellaArt;
    weather.cloudArt=new Image();weather.cloudArt.onload=()=>{if(fluid)draw();};weather.cloudArt.src=canvas.dataset.stormClouds||'';
    weather.shockArt=new Image();weather.shockArt.crossOrigin='anonymous';weather.shockArt.onload=()=>{const im=weather.shockArt,c=document.createElement('canvas');c.width=im.naturalWidth;c.height=im.naturalHeight;const cx=c.getContext('2d');cx.drawImage(im,0,0);const px=cx.getImageData(0,0,c.width,c.height).data;im.frames=[];for(let col=0;col<4;col++){const x0=[0,399,778,1149][col],x1=[399,778,1149,1536][col];let l=x1,r=x0,t=c.height,b=0;for(let y=0;y<c.height;y++)for(let x=x0;x<x1;x++)if(px[(y*c.width+x)*4+3]>40){l=Math.min(l,x);r=Math.max(r,x);t=Math.min(t,y);b=Math.max(b,y);}im.frames.push([l,t,Math.max(1,r-l+1),Math.max(1,b-t+1)]);}if(fluid)draw();};weather.shockArt.src=canvas.dataset.mattElectric||'';
  }
  let stormButtonAge=1,stormButtons=[];
  function stormSurface(x){
    if(!fluid)return null;if(!tiltFluid){const k=Math.max(0,Math.min(fluid.n-1,Math.floor(x/fluid.dx)));return fluid.h[k]>3?pageHeight-fluid.h[k]:null;}
    const f=tiltFluid,col=Math.max(0,Math.min(f.cols-1,Math.floor(x/f.dx)));for(let row=0;row<f.rows;row++)if(f.m[row*f.cols+col]>.2)return row*f.dy;return null;
  }
  function stormScene(dt){
    stormButtonAge+=dt;if(stormButtonAge>.75){stormButtonAge=0;stormButtons=[];document.querySelectorAll('button,a.nye-button,a.button,a.btn').forEach(el=>{if(el.disabled||el.closest('form,[data-paint-controls],[data-paint-playground]')||el.matches('[data-companion],[data-matt-hit]'))return;const r=el.getBoundingClientRect();if(r.width<35||r.height<20||r.width>width*.9||!el.getClientRects().length)return;stormButtons.push({left:r.left,right:r.right,top:r.top+window.scrollY,bottom:r.bottom+window.scrollY});});}
    const matt=crew?.hidden?null:mattGeometry(),wet=matt&&(samplePaint(matt.x,matt.y+matt.height/2+18).wet>.1||(!crew?.ownsMatt&&raft?.active&&['aboard','swimming'].includes(rider?.state)));
    return {width,floor:pageHeight,scroll:window.scrollY,viewportHeight:height,buttons:stormButtons,poolAt:stormSurface,wetAt:(x,y)=>samplePaint(x,y).wet>.08,matt,mattWet:!!wet,reduced:reduced.matches,impact:b=>{if(b.kind==='water'&&!tiltFluid)fluid.splash(b.end.x,24);}};
  }
  let spriteRequested = false;
  const mattHandle = document.querySelector('[data-matt-hit]');
  let pickup = null, holdTimer = 0, blockSpaceClick = false, drainFlash = 0;
  const mischief=window.NyeMattMischief?new window.NyeMattMischief():null;
  const luckDragon=new Image();let dragonRequested=false,ledgeAge=0,ledges=[];
  luckDragon.onerror=()=>{if(mischief?.flight)mischief.reset(rider);};
  const crew=window.NyeCompanions?new window.NyeCompanions({canvas,controls,redraw:()=>{if(fluid)draw();},announce,onDragonGrab:()=>mischief?.reset(rider)}):null;
  const villains=window.NyeVillains&&crew?new window.NyeVillains({canvas,controls,crew,redraw:()=>{if(fluid)draw();},announce}):null;
  const toys=window.NyePlayground?new window.NyePlayground({canvas,controls,raft,crew,villains,weather,announce,redraw:()=>{if(fluid)draw();},resume:()=>{paused=false;paintButtons();wake();},launch:(x,y)=>{raft.launch(x,y,gravity,width<600?112:140);raft.opacity=1;requestSprite();}}):null;
  controls.hidden = false; playground.hidden = false; canvas.hidden = false;

  function announce(text) { status.textContent = text; }
  const rgb = hex => [1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
  const colorCSS = color => 'rgb('+color.map(v=>Math.round(v)).join(',')+')';
  function measure() {
    mischief?.reset(rider);ledgeAge=1;weather?.clearStrike();stormButtonAge=1;
    document.body.classList.toggle('nye-has-preview',!!document.getElementById('PBarNextFrame'));
    if(pickup)finishPickup(true);
    if(rider?.state==='drain')rider.rescue();
    const oldWidth = width, oldPageHeight = pageHeight;
    width = document.documentElement.clientWidth;
    height = window.innerHeight;
    pageHeight = document.querySelector('[data-paint-floor]').getBoundingClientRect().bottom + window.scrollY;
    pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * pixelRatio); canvas.height = Math.round(height * pixelRatio);
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    if (!fluid) fluid = new window.NyeFluid(width, pageHeight, width < 600 ? 48 : 80);
    else fluid.resize(width, pageHeight);
    if (tiltFluid) tiltFluid.resize(width,pageHeight);
    if (raft && oldWidth && oldPageHeight) raft.resize(oldWidth,oldPageHeight,width,pageHeight);
    if (rider && oldWidth && oldPageHeight) rider.resize(oldWidth,oldPageHeight,width,pageHeight);
    if (oldWidth && oldWidth !== width) drops.forEach(p => { p.x *= width / oldWidth; });
    sources = [];
    document.querySelectorAll('.nye-art-wordmark img,.nye-header .nye-wordmark img').forEach(img => {
      const r = img.getBoundingClientRect();
      const clip = img.parentElement.getBoundingClientRect();
      tips.forEach(([x, y], i) => {
        const sx = r.left + x / 1254 * r.width, sy = r.top + y / 1254 * r.height;
        if (sx >= clip.left && sx <= clip.right && sy >= clip.top && sy <= clip.bottom) {
          sources.push({x:sx, y:sy + window.scrollY, color:ink[i], age:Math.random(), duration:.9 + Math.random() * 1.8, length:15 + Math.random() * 36});
        }
      });
    });
    draw();
  }
  function paintButtons() {
    document.querySelectorAll('[data-paint-action="pause"]').forEach(b => { b.textContent = paused ? 'Resume paint' : 'Pause paint'; b.setAttribute('aria-pressed', String(paused)); });
    document.querySelectorAll('[data-paint-action="flood"]').forEach(b => { b.textContent = flooding ? 'Stop flooding' : 'Fuck it. Flood it.'; b.setAttribute('aria-pressed', String(flooding)); });
    document.querySelectorAll('[data-paint-action="drain"]').forEach(b => { const label=plugOpen?'Put the bathtub plug back — stop draining':'Pull the bathtub plug — drain the paint'; if(b!==plugHandle)b.textContent=label; b.setAttribute('aria-label',label);b.title=label;b.setAttribute('aria-pressed', String(plugOpen)); });
    motionButton.textContent = motionWaiting ? 'Waiting for your phone…' : motionOn ? 'Tilt is on · turn off' : 'Tilt this shit';
    motionButton.setAttribute('aria-pressed',String(motionOn));
    motionButton.disabled = motionWaiting;
    document.body.classList.toggle('nye-paint-draining', draining && !paused);
  }
  function wake() {
    if (!paused && !document.hidden && !raf) { last = 0; raf = requestAnimationFrame(frame); }
  }
  function stop() { cancelAnimationFrame(raf); raf = 0; last = 0; }
  function disableMotion() {
    if(shake)shake.reset();
    motionOn=false;motionWaiting=false;clearTimeout(motionTimer);
    window.removeEventListener('devicemotion',onMotion);
    targetGravity.x=0;targetGravity.y=1;paintButtons();
  }
  function onMotion(event) {
    if(document.hidden)return;
    const a=event.accelerationIncludingGravity;
    if(!a || ![a.x,a.y,a.z].every(v=>typeof v==='number'&&Number.isFinite(v)) || Math.hypot(a.x,a.y,a.z)<.1)return;
    const angle=window.screen.orientation?.angle ?? window.orientation ?? 0;
    const g=window.NyeTiltFluid.screenGravity(a,angle);
    if(!g)return;
    lastMotion=performance.now();targetGravity.x=g.x;targetGravity.y=g.y;
    if(motionOn&&!paused&&!reduced.matches&&raft?.active&&rider?.state==='aboard'){
      const hit=shake?.feed(lastMotion,event.acceleration,a);
      if(hit){const projected=window.NyeTiltFluid.screenGravity(hit,angle);knockMatt(hit.strength,projected?.x);}
    }
    if(motionWaiting) {
      clearTimeout(motionTimer);motionWaiting=false;motionOn=true;
      if(!tiltFluid) {tiltFluid=new window.NyeTiltFluid(width,pageHeight);tiltFluid.importSurface(fluid);streaks=[];}
      if(!reduced.matches)paused=false;
      paintButtons();announce(paused?'Tilt is on. Resume paint when you want.':'Tilt is on. The whole page is your paint jar.');wake();
    }
  }
  async function toggleMotion() {
    if(motionOn){disableMotion();announce('Tilt off. Gravity is back to normal.');return;}
    if(motionWaiting)return;
    if(!window.isSecureContext || !window.DeviceMotionEvent || !window.NyeTiltFluid) {
      announce('This browser cannot read phone motion. The regular paint still works.');return;
    }
    motionWaiting=true;paintButtons();
    try {
      // Call directly from the button gesture: Safari requires this permission.
      if(typeof window.DeviceMotionEvent.requestPermission==='function') {
        const permission=await window.DeviceMotionEvent.requestPermission();
        if(permission!=='granted'){disableMotion();announce('Motion permission was not allowed. The regular paint still works.');return;}
      }
      window.addEventListener('devicemotion',onMotion,{passive:true});
      announce('Move your phone a little. Waiting for its motion sensor…');
      motionTimer=setTimeout(()=>{if(motionWaiting){disableMotion();announce('No motion data arrived. Try your phone’s main browser. The regular paint still works.');}},8000);
    } catch(error) {
      disableMotion();announce('Phone motion is unavailable here. The regular paint still works.');
    }
  }
  function particle(x, y, mass, color, velocity = 30, kind = 'paint') {
    if (drops.length >= 170) return;
    drops.push({x, y, vx:(Math.random() - 0.5) * 18, vy:velocity, r:Math.min(10,Math.max(4,Math.sqrt(mass/Math.PI)*.5)), mass, color, kind});
  }
  const paint = () => tiltFluid || fluid;
  function poolTop(x) {
    const k = Math.max(0, Math.min(fluid.n - 1, Math.floor(x / fluid.dx)));
    return pageHeight - fluid.h[k];
  }
  function step(dt) {
    drainFlash=Math.max(0,drainFlash-dt);
    plugLift=reduced.matches?Number(plugOpen):plugLift+(Number(plugOpen)-plugLift)*(1-Math.exp(-dt*10));
    advancePickup(dt);
    if(weather)weather.tick(dt,weather.mode==='rain'||weather.strike||weather.electric>0?stormScene(dt):undefined);
    const response=1-Math.exp(-dt*7);
    const fresh=motionOn && performance.now()-lastMotion<1800;
    gravity.x+=((fresh?targetGravity.x:0)-gravity.x)*response;
    gravity.y+=((fresh?targetGravity.y:1)-gravity.y)*response;
    const remaining = Math.max(0, width * pageHeight - paint().volume - drops.reduce((a, p) => a + p.mass, 0));
    if(weather && !draining && !flooding && remaining>width*2 && paint().fraction<.995)weather.emit(dt,width,particle);
    if (!draining && paint().fraction < .995 && !flooding && (!weather || weather.mode==='paint')) {
      sources.forEach(s => {
        s.age += dt;
        if (s.age >= s.duration) {
          particle(s.x + gravity.x*s.length, s.y + gravity.y*s.length, width*(.4+Math.random()*.2), s.color);
          s.age = 0; s.duration = .9 + Math.random() * 1.8;
        }
      });
    }
    if (flooding && remaining > 0) {
      floodTimer += dt;
      while (floodTimer >= 0.055 && drops.length < 170) {
        floodTimer -= 0.055;
        // Each rendered drop represents a short stream of paint. The surface
        // receives only the volume carried by arriving drops, never a CSS fill.
        const available = Math.max(0, width * pageHeight - paint().volume - drops.reduce((a, p) => a + p.mass, 0));
        const mass = Math.min(available, width * pageHeight / 600);
        particle(Math.random() * width, -12, mass, ink[Math.floor(Math.random()*ink.length)], 280);
      }
    }
    if(weather)weather.umbrella(dt,umbrellaGeometry(),drops,rider?.state,gravity);
    for (let i = drops.length - 1; i >= 0; i--) {
      const p = drops[i], previous={x:p.x,y:p.y}; p.vx += 1180 * gravity.x * dt; p.vy += 1180 * gravity.y * dt;
      p.vx *= Math.exp(-.15*dt); p.vy *= Math.exp(-.15*dt);
      p.x += p.vx * dt; p.y += p.vy * dt;
      if(weather)weather.intercept(p,previous);
      // Wet walls absorb impact. Tangential motion remains, so drops slide.
      if (p.x<p.r || p.x>width-p.r) {p.x=Math.max(p.r,Math.min(width-p.r,p.x));p.vx*= -.06;p.vy*=Math.exp(-9*dt);}
      if (tiltFluid) {
        const boundary=p.y<p.r || p.y>pageHeight-p.r;
        if (boundary) {p.y=Math.max(p.r,Math.min(pageHeight-p.r,p.y));p.vy*= -.06;p.vx*=Math.exp(-9*dt);}
        const onSide=p.x<=p.r+.1 || p.x>=width-p.r-.1;
        if (tiltFluid.contains(p.x,p.y) || boundary || onSide) {
          tiltFluid.add(p.x,p.y,p.mass,rgb(p.color));drops.splice(i,1);
        }
        continue;
      }
      if (p.y >= poolTop(p.x) - p.r) {
        const impact = poolTop(p.x);
        fluid.add(p.x, p.mass, rgb(p.color)); fluid.splash(p.x, Math.min(25, p.vy * 0.014));
        if(streaks.length<70)streaks.push({x:p.x,depth:3,life:7,color:p.color,phase:Math.random()*6,width:Math.min(18,p.r*1.5)});
        for (let j = 0; j < 3 && splashes.length < 70; j++) splashes.push({x:p.x,y:impact,vx:(Math.random() - 0.5) * 130,vy:-70 - Math.random() * 120,life:0.5 + Math.random() * 0.4,r:1 + Math.random() * 2,color:p.color});
        drops.splice(i, 1);
      }
    }
    for (let i = splashes.length - 1; i >= 0; i--) {
      const p = splashes[i]; p.life -= dt; p.vx += 900 * gravity.x * dt; p.vy += 900 * gravity.y * dt; p.x += p.vx * dt; p.y += p.vy * dt;
      if (p.life <= 0) splashes.splice(i, 1);
    }
    if (tiltFluid) tiltFluid.step(dt,gravity,draining);
    else fluid.step(dt, draining);
    for(let i=streaks.length-1;i>=0;i--){
      const p=streaks[i],k=Math.max(0,Math.min(fluid.n-1,Math.floor(p.x/fluid.dx)));
      p.life-=dt;p.x+=fluid.u[k]*dt*.35;p.depth+=dt*8;
      if(p.life<=0||fluid.h[k]<2)streaks.splice(i,1);
    }
    if (flooding && paint().fraction >= 0.995) {
      flooding = false; paintButtons(); announce('Bad Timeline. The page is full. Pull the plug.');
    }
    if (draining && paint().volume < 1 && drops.length === 0) {
      paint().clear(); draining = false; paused = true; plugLift=Number(plugOpen);paintButtons(); announce('All gone. Click the stopper to seal the drain and bring the paint back.');
    }
    toys?.step(dt,{width,height,scroll:window.scrollY,floor:pageHeight,paused,reduced:reduced.matches,liquidAt:samplePaint});
    stepRaft(dt);
    crew?.step(dt,{width,height,scroll:window.scrollY,floor:pageHeight,raft,paused,reduced:reduced.matches,rescue:mischief?.flight,poolAt:stormSurface,liquidAt:samplePaint,splash:(x,force)=>{if(!tiltFluid)fluid.splash(x,force);},riderState:rider?.state,mattHeld:!!pickup});
    if(crew?.env)villains?.step(dt,crew.env);
    spriteAge += dt;
    if (spriteReaction > 0) spriteReaction = Math.max(0, spriteReaction - dt);
  }
  function draw() {
    if(crew?.env)crew.env.paused=paused;
    const scroll = window.scrollY;
    ctx.clearRect(0, 0, width, height);
    if (!fluid) return;
    const highest = Math.max(...fluid.h), fluidTop = pageHeight-highest-scroll;
    const bottom=pageHeight-scroll;
    function surface(){
      ctx.moveTo(0,pageHeight-fluid.h[0]-scroll);
      for(let i=0;i<fluid.n-1;i++){
        const y=pageHeight-fluid.h[i]-scroll,next=pageHeight-fluid.h[i+1]-scroll;
        ctx.quadraticCurveTo((i+.5)*fluid.dx,y,(i+1)*fluid.dx,(y+next)/2);
      }
      ctx.quadraticCurveTo(width-fluid.dx/2,pageHeight-fluid.h[fluid.n-1]-scroll,width,pageHeight-fluid.h[fluid.n-1]-scroll);
    }
    if(!tiltFluid && highest>.05 && fluidTop<height && bottom>0){
      ctx.beginPath();surface();ctx.lineTo(width,bottom);ctx.lineTo(0,bottom);ctx.closePath();ctx.save();ctx.clip();
      const mixture=ctx.createLinearGradient(0,0,width,0);
      for(let i=0;i<fluid.n;i++)mixture.addColorStop(i/(fluid.n-1),colorCSS(fluid.colorAt(i)));
      ctx.globalAlpha=.95;ctx.fillStyle=mixture;ctx.fillRect(0,Math.max(0,fluidTop),width,height);
      streaks.forEach(p=>{
        const y=poolTop(p.x)-scroll+p.depth,sway=Math.sin(spriteAge*1.5+p.phase)*20;
        ctx.globalAlpha=p.life/7*.42;ctx.strokeStyle=p.color;ctx.lineWidth=p.width;
        ctx.beginPath();ctx.moveTo(p.x-20,y-8);ctx.bezierCurveTo(p.x+sway,y+15,p.x+45,y-15,p.x+66,y+14);ctx.stroke();
      });
      ctx.globalAlpha=.12;ctx.fillStyle='#151316';
      for(let y=Math.max(0,Math.floor(fluidTop/12)*12);y<Math.min(height,bottom);y+=12)for(let x=(y%24?6:0);x<width;x+=12)ctx.fillRect(x,y,1.3,1.3);
      ctx.restore();ctx.globalAlpha=1;ctx.beginPath();surface();ctx.strokeStyle='#25192c';ctx.lineWidth=3;ctx.stroke();ctx.strokeStyle='#e9e3ce';ctx.lineWidth=1;ctx.stroke();
    }
    if (tiltFluid) drawTiltPool(scroll);
    weather?.drawElectric(ctx,width,scroll,height);
    if(weather)weather.drawSky(ctx,width,scroll);
    if (!draining && !flooding && paint().fraction < .995 && (!weather || weather.mode==='paint')) sources.forEach(s => {
      const y = s.y - scroll;
      if (s.age <= 0 || y < -60 || y > height) return;
      const growth = Math.min(1, s.age / s.duration);
      const length = s.length * growth * growth;
      ctx.beginPath(); ctx.moveTo(s.x,y); ctx.quadraticCurveTo(s.x + gravity.x*length*.6 + 1.5,y + gravity.y*length*.6,s.x + gravity.x*length,y + gravity.y*length);
      ctx.strokeStyle = s.color; ctx.lineWidth = 1.8; ctx.lineCap = 'round'; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(s.x + gravity.x*length, y + gravity.y*length, 1.5 + growth * 2, 2 + growth * 3, -Math.atan2(gravity.x,gravity.y), 0, Math.PI * 2); ctx.fillStyle = s.color; ctx.fill();
    });
    drops.concat(splashes).forEach(p => {
      const y = p.y - scroll; if (y < -30 || y > height + 30) return;
      if(p.kind==='rain'){
        const speed=Math.max(1,Math.hypot(p.vx,p.vy)),length=Math.min(22,7+speed*.008);
        ctx.beginPath();ctx.moveTo(p.x,y);ctx.lineTo(p.x-p.vx/speed*length,y-p.vy/speed*length);ctx.strokeStyle=p.color;ctx.lineWidth=1.4;ctx.stroke();return;
      }
      const radius = p.mass ? p.r * .75 : p.r; // Finer falling drops; carried paint volume stays unchanged.
      ctx.beginPath(); ctx.ellipse(p.x,y,radius,radius * Math.min(2.2,1 + Math.hypot(p.vx,p.vy) / 650),-Math.atan2(p.vx,p.vy),0,Math.PI * 2);
      ctx.fillStyle = p.color; ctx.fill(); ctx.strokeStyle = '#241824'; ctx.lineWidth = 0.6; ctx.stroke();
    });
    if(crew&&!crew.env)crew.step(0,{width,height,scroll,floor:pageHeight,raft,paused,reduced:reduced.matches,rescue:mischief?.flight,poolAt:stormSurface,liquidAt:samplePaint,splash:(x,force)=>{if(!tiltFluid)fluid.splash(x,force);},riderState:rider?.state,mattHeld:!!pickup});
    drawMattDrain(scroll);
    drawRaft(scroll);
    drawMattMischief(scroll);
    drawSwimmer(scroll);
    drawMattMischief(scroll,true);
    crew?.draw(ctx,scroll,{hideMatt:!!weather?.isShocking()});
    if(weather?.open>.04){weather.positionUmbrella(umbrellaGeometry());weather.drawUmbrella(ctx,scroll);}
    villains?.draw(ctx,scroll);
    if(toys){toys.env={width,height,scroll,floor:pageHeight,paused,reduced:reduced.matches,liquidAt:samplePaint};toys.draw(ctx,scroll);}
    weather?.drawShock(ctx,crew?.hidden?null:mattGeometry(),scroll,reduced.matches);
    weather?.drawStrike(ctx,width,scroll,height);
    updateMattHandle(scroll);
    drawSprite();
  }
  const paintTexture=document.createElement('canvas');
  const textureCtx=paintTexture.getContext('2d');
  function drawTiltPool(scroll) {
    const f=tiltFluid,w=f.cols,h=f.rows,dx=f.dx,dy=f.dy;
    const first=Math.max(-1,Math.floor(scroll/dy)-1),end=Math.min(h-1,Math.ceil((scroll+height)/dy));
    const mass=(x,y)=>f.m[Math.max(0,Math.min(h-1,y))*w+Math.max(0,Math.min(w-1,x))];
    const threshold=.09, shape=new Path2D(),edge=new Path2D();
    for(let y=first;y<=end;y++)for(let x=-1;x<w;x++) {
      const vals=[mass(x,y),mass(x+1,y),mass(x+1,y+1),mass(x,y+1)];
      if(vals.every(v=>v<threshold))continue;
      const x0=(x+.5)*dx,y0=(y+.5)*dy-scroll;
      const corners=[[x0,y0],[x0+dx,y0],[x0+dx,y0+dy],[x0,y0+dy]],polygon=[],cross=[];
      for(let j=0;j<4;j++) {
        const next=(j+1)%4,inside=vals[j]>=threshold;
        if(inside)polygon.push(corners[j]);
        if(inside!==(vals[next]>=threshold)) {
          const t=(threshold-vals[j])/(vals[next]-vals[j]);
          const p=[corners[j][0]+(corners[next][0]-corners[j][0])*t,corners[j][1]+(corners[next][1]-corners[j][1])*t];
          polygon.push(p);cross.push(p);
        }
      }
      if(polygon.length){shape.moveTo(...polygon[0]);polygon.slice(1).forEach(p=>shape.lineTo(...p));shape.closePath();}
      for(let j=0;j+1<cross.length;j+=2){edge.moveTo(...cross[j]);edge.lineTo(...cross[j+1]);}
    }
    ctx.save();ctx.beginPath();ctx.rect(0,-scroll,width,pageHeight);ctx.clip();ctx.clip(shape);
    // This tiny procedural color field is interpolated under a crisp contour;
    // it is not an enlarged artwork asset. Pigments follow the simulated flow.
    const rows=end-first+2;
    paintTexture.width=w+2;paintTexture.height=rows;
    const pixels=textureCtx.createImageData(w+2,rows);
    for(let y=0;y<rows;y++)for(let x=0;x<w+2;x++) {
      const i=Math.max(0,Math.min(h-1,first+y))*w+Math.max(0,Math.min(w-1,x-1));
      const color=f.colorAt(i),k=(y*(w+2)+x)*4;
      pixels.data[k]=color[0];pixels.data[k+1]=color[1];pixels.data[k+2]=color[2];pixels.data[k+3]=242;
    }
    textureCtx.putImageData(pixels,0,0);ctx.imageSmoothingEnabled=true;
    ctx.drawImage(paintTexture,-dx,first*dy-scroll,(w+2)*dx,rows*dy);
    ctx.globalAlpha=.12;ctx.fillStyle='#151316';
    for(let y=Math.floor(scroll/12)*12-scroll;y<height;y+=12)for(let x=0;x<width;x+=12)ctx.fillRect(x,y,1.3,1.3);
    ctx.restore();ctx.strokeStyle='#25192c';ctx.lineWidth=3;ctx.stroke(edge);ctx.strokeStyle='#e9e3ce';ctx.lineWidth=.8;ctx.stroke(edge);
  }
  function requestSprite() {
    if(!spriteRequested){spriteRequested=true;sprite.src=mascot.dataset.sprite;}
  }
  function samplePaint(x,y) {
    if(x<0||x>width||y<0||y>pageHeight)return {wet:0,vx:0,vy:0};
    if(!tiltFluid) {
      const pos=Math.max(0,Math.min(fluid.n-1,x/fluid.dx-.5)),a=Math.floor(pos),b=Math.min(fluid.n-1,a+1),t=pos-a;
      const surface=pageHeight-(fluid.h[a]*(1-t)+fluid.h[b]*t);
      return {wet:Math.max(0,Math.min(1,(y-surface)/12+.5)),vx:(fluid.u[a]+fluid.u[a+1])*.5,vy:0};
    }
    const f=tiltFluid,px=Math.max(0,Math.min(f.cols-1,x/f.dx-.5)),py=Math.max(0,Math.min(f.rows-1,y/f.dy-.5));
    const ax=Math.floor(px),ay=Math.floor(py),bx=Math.min(f.cols-1,ax+1),by=Math.min(f.rows-1,ay+1),tx=px-ax,ty=py-ay;
    const mass=(f.m[ay*f.cols+ax]*(1-tx)+f.m[ay*f.cols+bx]*tx)*(1-ty)+(f.m[by*f.cols+ax]*(1-tx)+f.m[by*f.cols+bx]*tx)*ty;
    return {wet:Math.max(0,Math.min(1,(mass-.09)/.5)),vx:(f.u[ay*(f.cols+1)+ax]+f.u[ay*(f.cols+1)+ax+1])*.5,vy:(f.v[ay*f.cols+ax]+f.v[(ay+1)*f.cols+ax])*.5};
  }
  function launchPoint() {
    if(!tiltFluid){const x=width*.6;return {x,y:poolTop(x)-10};}
    const f=tiltFluid,length=Math.hypot(gravity.x,gravity.y),gx=length>.1?gravity.x/length:0,gy=length>.1?gravity.y/length:1;
    let best=null,score=Infinity;
    for(let y=0;y<f.rows;y++)for(let x=0;x<f.cols;x++) {
      const i=y*f.cols+x;if(f.m[i]<.2)continue;
      const sx=(x+.5)*f.dx,sy=(y+.5)*f.dy;
      if(samplePaint(sx-gx*f.dx*1.5,sy-gy*f.dy*1.5).wet>.2)continue;
      const distance=Math.abs(sx-width*.6)+Math.abs(sy-pageHeight*.65)*.04;
      if(distance<score){score=distance;best={x:sx-gx*12,y:sy-gy*12};}
    }
    return best;
  }
  function stepRaft(dt) {
    if(!raft)return;
    const volume=paint().volume;
    if(!raft.active && volume>width*12) {
      const point=launchPoint();
      if(point){raft.launch(point.x,point.y,gravity,width<600?112:140);requestSprite();}
    }
    if(toys?.held?.id!=='raft')raft.step(dt,gravity,samplePaint,{width,height:pageHeight},volume>width*1.5||!!toys?.raftSummoned);
    if(!raft.active&&pickup)finishPickup(true);
    if(rider){
      const before=rider.state;ledgeAge+=dt;
      if(mischief&&['held','falling','hanging'].includes(rider.state)&&ledgeAge>.12){
        ledgeAge=0;ledges=[];
        document.querySelectorAll('main a[class*="btn"],main a[class*="button"],main button,header a,footer a,footer button').forEach(el=>{
          if(el===mattHandle||el.disabled||el.closest('form,[data-paint-controls],[data-paint-mascot]')||el.getAttribute('aria-hidden')==='true')return;
          const r=el.getBoundingClientRect();
          if(r.width<32||r.height<22||r.bottom<0||r.top>height)return;
          ledges.push({id:el,x:r.left,y:r.bottom+window.scrollY,w:r.width});
        });
      }
      const controlled=mischief?.tick(dt,rider,raft,gravity,{width,height:pageHeight,top:window.scrollY,viewHeight:height},ledges,pickup?pickupPoint():null,Math.min(width<600?78:84,209/pixelRatio),!reduced.matches);
      if(mischief?.flight&&crew&&samplePaint(mischief.flight.x,mischief.flight.y).wet>.2){const f=mischief.flight,d=crew.actors.dragon;d.x=f.x;d.y=f.y+30;d.visible=true;crew.beginWater(d,'dragon');const a=crew.actors.matt;a.x=rider.body.x;a.y=rider.body.y+29;crew.beginWater(a,'matt');mischief.reset(rider);rider.reset();}
      if(mischief?.event)announce(mischief.event);
      if(mischief?.flight&&!dragonRequested){dragonRequested=true;luckDragon.src=canvas.dataset.luckDragon;}
      const landed=controlled?false:rider.step(dt,gravity,samplePaint,{width,height:pageHeight},raft,volume>width*1.5||!!toys?.raftSummoned);
      if(crew&&!crew.ownsMatt&&rider.state==='swimming'&&!pickup){const a=crew.actors.matt;a.x=rider.body.x;a.y=rider.body.y+29;a.vy=rider.body.vy;crew.ownsMatt=true;crew.beginWater(a,'matt');mischief?.reset(rider);rider.reset();}
      if(landed)splashMatt();if(before!==rider.state)paintButtons();
    }
  }
  function drawRaft(scroll) {
    if(!raft?.active||raft.opacity<=0)return;
    const y=raft.y-scroll;
    if(y < -150 || y > height+150)return;
    const half=raft.width/2;
    ctx.save();ctx.translate(raft.x,y);ctx.rotate(raft.angle);ctx.globalAlpha=raft.opacity;
    // Native illustrated leaf wrap: preserve its proportions and align the riding surface.
    if(raftArt.complete&&raftArt.naturalWidth){const artWidth=Math.min(raft.width*1.2,1806/pixelRatio),artHeight=artWidth*365/1806;ctx.drawImage(raftArt,31,242,1806,365,-artWidth/2,-13,artWidth,artHeight);}
    else {
    // Inked wrapper, stitched folds, ash and an ember: procedural vector art.
    ctx.beginPath();ctx.moveTo(-half+10,-10);ctx.quadraticCurveTo(0,-16,half-8,-10);ctx.quadraticCurveTo(half+5,-1,half-6,9);ctx.quadraticCurveTo(0,17,-half+6,10);ctx.quadraticCurveTo(-half-6,1,-half+10,-10);ctx.closePath();
    ctx.fillStyle='#88542f';ctx.fill();ctx.lineWidth=3;ctx.strokeStyle='#17111a';ctx.stroke();ctx.save();ctx.clip();
    ctx.beginPath();ctx.moveTo(-half,-5);ctx.quadraticCurveTo(0,-11,half,-5);ctx.strokeStyle='#c49357';ctx.lineWidth=4;ctx.stroke();
    ctx.strokeStyle='#402c22';ctx.lineWidth=1.4;
    for(let x=-half+20;x<half;x+=16){ctx.beginPath();ctx.moveTo(x-5,-13);ctx.quadraticCurveTo(x+10,0,x+2,15);ctx.stroke();}
    ctx.restore();
    ctx.beginPath();ctx.ellipse(-half+6,0,8,11,-.14,0,Math.PI*2);ctx.fillStyle='#d2743b';ctx.fill();ctx.strokeStyle='#17111a';ctx.lineWidth=2;ctx.stroke();
    ctx.beginPath();ctx.ellipse(-half+2,0,6,9,-.14,0,Math.PI*2);ctx.fillStyle='#aaa398';ctx.fill();
    ctx.strokeStyle='#49424b';ctx.lineWidth=1.2;ctx.beginPath();ctx.moveTo(-half-1,-5);ctx.lineTo(-half+4,-1);ctx.lineTo(-half,3);ctx.lineTo(-half+4,6);ctx.stroke();
    }
    if(!weather?.isShocking()&&!crew?.ownsMatt&&!crew?.hidden&&(!rider||rider.state==='aboard')&&sprite.complete&&sprite.naturalWidth) {
      const size=Math.min(width<600?78:84,209/pixelRatio),sh=size*225/209;
      const index=Math.abs(raft.spin)>.25?2:(Math.floor(spriteAge*1.4)%4===0?1:0);
      if(!crew?.drawLifeActor(ctx,{x:0,y:-7,w:size,h:sh,dir:1},'matt'))ctx.drawImage(sprite,index*209,0,209,225,-size/2,-sh-7,size,sh);
    }
    ctx.restore();
  }
  function knockMatt(strength=1,shakeDirection=0) {
    if(!raft?.active||!rider){announce('Let the paint build first. Matt needs to launch before he can fall off.');return;}
    // Favor the open side when the raft is close to a wall.
    const direction=raft.x>width*.7?-1:raft.x<width*.3?1:(shakeDirection<0?-1:1);
    if(rider.knock(raft,gravity,strength,direction)){
      announce('Matt overboard. He’s got this.');paintButtons();
    }
  }
  function splashMatt() {
    const b=rider.body,n=Math.hypot(gravity.x,gravity.y)||1,gx=gravity.x/n,gy=gravity.y/n;
    const color=tiltFluid?colorCSS(tiltFluid.colorAt(tiltFluid.index(b.x,b.y))):colorCSS(fluid.colorAt(b.x/fluid.dx));
    for(let i=0;i<12&&splashes.length<70;i++){
      const sideways=(Math.random()-.5)*180,up=65+Math.random()*95;
      splashes.push({x:b.x,y:b.y,vx:gy*sideways-gx*up,vy:-gx*sideways-gy*up,life:.5+Math.random()*.35,r:1.5+Math.random()*2,color});
    }
    if(!tiltFluid)fluid.splash(b.x,16);
    else {
      const f=tiltFluid,k=f.index(b.x,b.y),x=k%f.cols,y=Math.floor(k/f.cols);
      f.u[y*(f.cols+1)+Math.max(1,x)]-=18;
      f.u[y*(f.cols+1)+Math.min(f.cols-1,x+1)]+=18;
    }
  }
  function drawSwimmer(scroll) {
    if(weather?.isShocking()||crew?.hidden||!rider||rider.state==='aboard'||!rider.body.active||!sprite.complete||!sprite.naturalWidth)return;
    const b=rider.body,y=b.y-scroll;if(y < -150||y>height+150)return;
    if(rider.state==='held'||rider.state==='hanging'){drawHeldMatt(scroll);return;}
    const swimming=rider.state==='swimming',size=Math.min(width<600?78:84,209/pixelRatio);
    const rowY=swimming?842:0,sourceHeight=swimming?200:225;
    // Reserve the visible fist while sheltering; other paddle poses lower it underwater.
    const sequence=[0,1,2,3,2,1],col=swimming?(weather?.open>.04?1:sequence[Math.floor(rider.age*5)%sequence.length]):2;
    const sh=size*sourceHeight/209;
    ctx.save();ctx.translate(b.x,y);ctx.rotate(b.angle);ctx.globalAlpha=b.opacity;
    if(swimming){ctx.save();ctx.beginPath();ctx.rect(-size,-sh,size*2,sh+4);ctx.clip();}
    ctx.drawImage(sprite,col*209,rowY,209,sourceHeight,-size/2,-sh+29,size,sh);
    if(swimming){
      ctx.restore();
      // Short paddle ripples surround the immersed waist; the body's actual
      // height and pitch still come from paint buoyancy, current and gravity.
      const spread=26+(Math.sin(rider.age*7)+1)*4;
      ctx.strokeStyle='#eadfc8';ctx.lineWidth=1.3;ctx.beginPath();ctx.ellipse(0,3,spread,4,0,.15,Math.PI-.15);ctx.stroke();
      ctx.strokeStyle='#352538';ctx.beginPath();ctx.ellipse(0,4,spread+5,5,0,Math.PI+.2,Math.PI*2-.2);ctx.stroke();
    }
    ctx.restore();
  }
  function mattGeometry() {
    if(crew?.ownsMatt&&!crew.hidden)return crew.mattGeometry();
    if(!raft?.active||!rider||rider.state==='drain')return null;
    const aboard=rider.state==='aboard',b=aboard?raft:rider.body;
    if(!b.active||b.opacity<.15)return null;
    const size=Math.min(width<600?78:84,209/pixelRatio);
    const sourceHeight=['held','hanging','swimming'].includes(rider.state)?200:225,sh=size*sourceHeight/209;
    const visible=rider.state==='swimming'?Math.max(44,sh-25):sh;
    const offset=aboard?-7-sh/2:rider.state==='swimming'?16.5-sh/2:29-sh/2;
    return {x:b.x-Math.sin(b.angle)*offset,y:b.y+Math.cos(b.angle)*offset,size,height:visible,angle:b.angle};
  }
  function umbrellaGeometry() {
    if(crew?.hidden||weather?.isShocking()||!raft?.active||!rider||!['aboard','swimming'].includes(rider.state)||gravity.y<.25)return null;
    // The companion owns walking, climbing, swimming recovery and being carried.
    // Those poses must never inherit a stale raft umbrella.
    if(crew?.ownsMatt)return null;
    const g=mattGeometry();if(!g)return null;
    const size=Math.min(width<600?78:84,209/pixelRatio),angle=g.angle,co=Math.cos(angle),si=Math.sin(angle);
    const point=(origin,x,y)=>({x:origin.x+co*x-si*y,y:origin.y+si*x+co*y});
    if(rider.state==='swimming'){
      const sh=size*200/209;
      g.grip=point(rider.body,(121-209/2)*size/209,-sh+29+117*size/209);
      g.gripRadius=3*size/84;return g;
    }
    const im=crew?.lifeImages?.matt;
    if(im?.frames){
      const n=crew.lifeIndex('matt'),f=im.frames[n],scale=crew.mattSpriteScale({h:size*225/209},im,'life');
      const hands=[[300,355],[680,355],[1066,354],[1446,352],[300,855],[681,855],[1066,858],[1447,852]],hand=hands[n];
      const dh=f[3]*scale;
      const center=point(raft,0,-7-dh/2);
      return {...g,...center,height:dh,grip:point(raft,(hand[0]-f[0]-f[2]/2)*scale,-7-dh+(hand[1]-f[1])*scale),gripRadius:Math.max(1.5,14*scale)};
    }
    if(!sprite.complete||!sprite.naturalWidth)return null;
    const n=Math.abs(raft.spin)>.25?2:(Math.floor(spriteAge*1.4)%4===0?1:0),hands=[[140,121],[134,127],[134,130]],hand=hands[n];
    g.grip=point(raft,(hand[0]-209/2)*size/209,-7-size*225/209+hand[1]*size/209);g.gripRadius=3*size/84;return g;
  }
  function updateMattHandle(scroll) {
    if(!mattHandle)return;
    if(crew?.ownsMatt||crew?.hidden){mattHandle.hidden=true;return;}
    const r=mattGeometry();
    const visible=r&&sprite.complete&&sprite.naturalWidth&&r.y-scroll>-100&&r.y-scroll<height+100;
    mattHandle.hidden=!visible&&!pickup;
    if(!r)return;
    const hw=Math.min(width,Math.abs(Math.cos(r.angle))*r.size+Math.abs(Math.sin(r.angle))*r.height);
    const hh=Math.abs(Math.sin(r.angle))*r.size+Math.abs(Math.cos(r.angle))*r.height;
    mattHandle.style.left=Math.max(0,Math.min(width-hw,r.x-hw/2))+'px';mattHandle.style.top=(r.y-scroll-hh/2)+'px';
    mattHandle.style.width=hw+'px';mattHandle.style.height=hh+'px';
    if(mischief?.latch){const top=Math.max(r.y-scroll-hh/2,mischief.latch.y-scroll+6);mattHandle.style.top=top+'px';mattHandle.style.height=Math.max(24,r.y-scroll+hh/2-top)+'px';}
    mattHandle.dataset.mattState=rider.state;mattHandle.dataset.clinging=String(!!mischief?.latch);
    mattHandle.disabled=paused;mattHandle.dataset.held=String(rider.state==='held');
    const label=mischief?.latch?'Little Matt is hanging onto a button. Hold and pull him away, or tap to help him aboard.':rider.state==='held'?'Little Matt picked up. Release to drop.':rider.state==='aboard'?'Little Matt. Tap to knock him off; hold and drag to pick him up.':'Little Matt. Tap to help him aboard; hold and drag to pick him up.';
    if(mattHandle.getAttribute('aria-label')!==label)mattHandle.setAttribute('aria-label',label);
  }
  function tapMatt() {
    if(paused||!raft?.active)return;
    if(rider.state==='aboard')knockMatt();
    else if(rider.rescue()){mischief?.reset();announce('Back on the blunt.');paintButtons();}
  }
  function pickupPoint() {
    return {x:Math.max(12,Math.min(width-12,pickup.x)),y:Math.max(0,Math.min(pageHeight,pickup.y+window.scrollY))};
  }
  function beginPickup() {
    if(!pickup||paused||rider.state==='held')return;
    if(rider.grab(raft,gravity,pickupPoint())){announce('Got his hoodie. Let go to drop him.');paintButtons();draw();}
  }
  function finishPickup(cancelled=false) {
    clearTimeout(holdTimer);holdTimer=0;
    if(!pickup)return;
    const previous=pickup;pickup=null;
    if(cancelled)mischief?.reset(rider);
    if(rider.state==='held'){
      if(!cancelled&&overMattDrain(previous)){mischief?.reset();sendDownDrain();}
      else if(mischief?.latch&&!cancelled){rider.state='hanging';rider.grip=null;}
      else rider.release(raft,gravity,cancelled);
    }
    else if(!cancelled)tapMatt();
    if(previous.id!==null&&mattHandle.hasPointerCapture?.(previous.id))mattHandle.releasePointerCapture(previous.id);
    paintButtons();draw();
  }
  function advancePickup(dt) {
    if(!pickup||pickup.id===null||rider.state!=='held')return;
    // A narrow edge zone lets a held character travel through the document;
    // ordinary page gestures never enter this captured-pointer path.
    const direction=pickup.y<48?-1:pickup.y>height-48?1:0;
    if(direction)window.scrollBy({top:direction*350*dt,behavior:'instant'});
    rider.moveGrip(pickupPoint());
  }
  if(mattHandle){
    mattHandle.addEventListener('pointerdown',event=>{
      if(paused||pickup||!raft?.active||event.button!==0||event.isPrimary===false)return;
      event.preventDefault();mattHandle.focus({preventScroll:true});
      pickup={id:event.pointerId,x:event.clientX,y:event.clientY,startX:event.clientX,startY:event.clientY};
      mattHandle.setPointerCapture(event.pointerId);holdTimer=setTimeout(beginPickup,300);
    });
    mattHandle.addEventListener('pointermove',event=>{
      if(!pickup||event.pointerId!==pickup.id)return;
      pickup.x=event.clientX;pickup.y=event.clientY;
      if(Math.hypot(pickup.x-pickup.startX,pickup.y-pickup.startY)>7)beginPickup();
      if(rider.state==='held')rider.moveGrip(pickupPoint());
    });
    mattHandle.addEventListener('pointerup',event=>{if(pickup&&event.pointerId===pickup.id)finishPickup();});
    mattHandle.addEventListener('pointercancel',()=>finishPickup(true));
    mattHandle.addEventListener('lostpointercapture',()=>finishPickup(true));
    mattHandle.addEventListener('contextmenu',event=>event.preventDefault());
    mattHandle.addEventListener('click',event=>{if(event.detail===0&&!pickup)tapMatt();});
    mattHandle.addEventListener('keydown',event=>{
      if(paused)return;
      if(event.key.toLowerCase()==='p'&&!pickup){
        event.preventDefault();const r=mattGeometry();if(!r)return;
        pickup={id:null,x:r.x,y:r.y-window.scrollY,startX:r.x,startY:r.y-window.scrollY};beginPickup();
      }else if(pickup&&rider.state==='held'){
        if(event.key.toLowerCase()==='d'){event.preventDefault();const d=mattDrain();pickup.x=d.x;pickup.y=d.y-window.scrollY;finishPickup();return;}
        const directions={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]};
        if(directions[event.key]){event.preventDefault();const d=directions[event.key],step=event.shiftKey?50:20;
          pickup.x+=d[0]*step;pickup.y+=d[1]*step;rider.moveGrip(pickupPoint());
        }else if([' ','Enter','Escape'].includes(event.key)){event.preventDefault();if(event.key===' ')blockSpaceClick=true;finishPickup(event.key==='Escape');}
      }
    });
    mattHandle.addEventListener('keyup',event=>{if(event.key===' '&&blockSpaceClick){event.preventDefault();blockSpaceClick=false;}});
    window.addEventListener('blur',()=>finishPickup(true));
  }
  function mattDrain(){return {x:Math.max(62,Math.min(110,width*.22)),y:pageHeight-70};}
  function overMattDrain(p){
    const d=mattDrain();return plugOpen&&Math.abs(p.x-d.x)<52&&Math.abs(p.y+window.scrollY-d.y)<65;
  }
  function sendDownDrain(){
    if(reduced.matches){rider.rescue();announce('Secret shortcut. Back on the blunt.');return;}
    const d=mattDrain(),exit={x:Math.max(50,width*.15),y:Math.max(80,window.scrollY+height*.23),vx:Math.min(440,width*.62)};
    if(rider.enterDrain(d,exit)){drainFlash=1.4;announce('Wrong pipe. Incoming!');}
  }
  function drawMattDrain(scroll){
    const d=mattDrain(),y=d.y-scroll,visible=y>-110&&y<height+110;
    if(plugHandle){
      plugHandle.hidden=!visible;
      Object.assign(plugHandle.style,{left:(d.x-64)+'px',top:(y-65)+'px',width:'180px',height:'126px'});
      plugHandle.dataset.state=plugOpen?(draining?'draining':'open'):'sealed';
      plugHandle.dataset.documentY=String(Math.round(d.y));
      plugHandle.dataset.volume=String(Math.round(paint().volume));
    }
    if(!visible)return;
    ctx.save();ctx.translate(d.x,y);
    const baseScale=Math.min((width<600?112:124)/836,1/pixelRatio);
    if(plugArt.complete&&plugArt.naturalWidth){
      ctx.drawImage(plugArt,42,186,836,648,(42-460)*baseScale,(186-540)*baseScale,836*baseScale,648*baseScale);
    }else{
      ctx.beginPath();ctx.ellipse(0,0,48,31,0,0,Math.PI*2);ctx.fillStyle='#161219';ctx.fill();ctx.strokeStyle='#99869e';ctx.lineWidth=5;ctx.stroke();
    }
    if(draining&&paint().volume>1&&plugLift>.15){
      const wetness=Math.min(1,paint().volume/(width*14)),spin=reduced.matches?0:spriteAge*4.2;
      const radius=48+32*wetness;
      // Several interleaved pigment ribbons spiral into the actual page-bottom outlet.
      ctx.save();ctx.globalAlpha=wetness*plugLift;ctx.lineCap='round';
      for(let band=0;band<5;band++){
        const k=Math.min(fluid.n-1,Math.floor((d.x+band*fluid.dx)/fluid.dx));
        ctx.strokeStyle=band===4?'#e7d9e5':colorCSS(fluid.colorAt(k));ctx.lineWidth=band===4?1.2:5-band*.5;
        ctx.beginPath();
        for(let i=0;i<=84;i++){
          const t=i/84,r=5+radius*(1-t),a=spin+band*Math.PI*.4+t*Math.PI*4.4;
          const x=Math.cos(a)*r,sy=Math.sin(a)*r*.38-7*(1-t);
          if(!i)ctx.moveTo(x,sy);else ctx.lineTo(x,sy);
        }ctx.stroke();
      }
      if(!reduced.matches)for(let i=0;i<9;i++){
        const t=(spriteAge*.55+i/9)%1,r=radius*(1-t),a=spin+i*2.399+t*5;
        ctx.beginPath();ctx.ellipse(Math.cos(a)*r,Math.sin(a)*r*.38-7*(1-t),1.3+2*(1-t),.8+1.1*(1-t),a,0,Math.PI*2);ctx.fillStyle=i%2?'#ccb6d1':colorCSS(fluid.colorAt(fluid.n*.2));ctx.fill();
      }
      ctx.restore();
    }
    // The stopper lifts, tilts and rests beside the drain. Its short chain is part of the native artwork.
    const lift=plugLift*plugLift*(3-2*plugLift);
    ctx.save();ctx.translate(lift*72,-lift*25-Math.sin(lift*Math.PI)*28);ctx.rotate(-lift*.55);
    if(plugArt.complete&&plugArt.naturalWidth){
      const scale=baseScale*1.08;
      ctx.drawImage(plugArt,913,381,591,493,(913-1140)*scale,(381-610)*scale,591*scale,493*scale);
    }else{ctx.beginPath();ctx.ellipse(0,0,32,23,0,0,Math.PI*2);ctx.fillStyle='#232025';ctx.fill();ctx.strokeStyle='#b099bb';ctx.lineWidth=2;ctx.stroke();}
    ctx.restore();
    if(rider?.state==='held'&&plugOpen){ctx.font='bold 10px Courier New';ctx.textAlign='center';ctx.fillStyle='#e9e3ce';ctx.fillText(pickup&&overMattDrain(pickup)?'LET GO.':'DROP HIM?',0,-65);}
    ctx.restore();
  }
  function drawHeldMatt(scroll) {
    if(crew&&samplePaint(rider.body.x,rider.body.y).wet>.12){const b=rider.body;if(crew.drawWaterActor(ctx,{x:b.x,y:b.y+29,w:58,h:104,dir:1,pose:'struggle',aqua:{state:'held'}},'matt',scroll))return;}
    if(crew?.rig?.ready){
      const b=rider.body,l=mischief?.latch;
      const hands=l?[-1,1].map(side=>({x:l.x+side*20,y:l.y-scroll})):null;
      crew.rig.draw(ctx,{x:b.x,y:b.y-scroll+29,height:104,angle:b.angle,hands,held:true,age:rider.age,opacity:b.opacity,grip:pickup?{x:pickup.x,y:pickup.y}:null});
      return;
    }
    const b=rider.body,size=Math.min(width<600?78:84,209/pixelRatio),scale=size/209,sh=200*scale;
    const top=29-sh,sequence=[0,1,2,3,4,3,2,1],col=sequence[Math.floor(rider.age*8)%sequence.length];
    ctx.save();ctx.translate(b.x,b.y-scroll);ctx.rotate(b.angle);ctx.globalAlpha=b.opacity;
    // Existing arm poses plus independently rotating lower legs make a small
    // kicking puppet. Every sampled source region is drawn smaller than native.
    const hip=top+133*scale;
    for(const side of [-1,1]){
      ctx.save();ctx.translate(side*12,hip);ctx.rotate(Math.sin(rider.age*12+side*1.7)*.28);
      const sx=col*209+(side<0?0:104.5),destX=side<0?-size/2+12:-12;
      ctx.drawImage(sprite,sx,842+128,104.5,72,destX,-5*scale,size/2,72*scale);ctx.restore();
    }
    ctx.drawImage(sprite,col*209,842,209,136,-size/2,top,size,136*scale);
    ctx.restore();
  }
  function drawMattMischief(scroll,foreground=false){
    if(weather?.isShocking()||crew?.hidden||!mischief||!rider?.body.active)return;
    const b=rider.body,l=mischief.latch,f=mischief.flight;
    if(!foreground&&f&&luckDragon.complete&&luckDragon.naturalWidth){
      const w=width<600?150:180,h=w*luckDragon.naturalHeight/luckDragon.naturalWidth;
      const animated=crew?.drawLifeActor(ctx,{x:f.x,y:f.y+30,w,h,dir:f.endX<f.startX?-1:1},'dragon',scroll,{opacity:Math.min(1,f.age*4)});
      if(!animated){ctx.save();ctx.translate(f.x,f.y-scroll+12);if(f.endX<f.startX)ctx.scale(-1,1);ctx.globalAlpha=Math.min(1,f.age*4);ctx.drawImage(luckDragon,-w*.55,-h*.3,w,h);ctx.restore();}
    }
    if(!l||!foreground)return;
    // The shared sprite rig draws the actual illustrated hands over the ledge.
  }

  function drawSprite() {
    if (!spriteCtx || !sprite.complete || !sprite.naturalWidth || !spriteVisible) return;
    let index;
    if (paused || reduced.matches) index = colorIndex === 0 ? 0 : colorIndex === 1 ? 24 : 33;
    else if (spriteReaction > 0) index = Math.min(35, 6 + Math.floor((2.5 - spriteReaction) * 12));
    else { const idle = [0,1,2,1,0,1]; index = idle[Math.floor(spriteAge * 2) % idle.length]; }
    if (index === spriteFrame) return;
    spriteFrame = index;
    const rows = [0,225,438,633,842,1042,1254], row = Math.floor(index / 6), col = index % 6;
    const h = rows[row + 1] - rows[row];
    spriteCtx.clearRect(0,0,209,225);
    spriteCtx.drawImage(sprite,col * 209,rows[row],209,h,0,225 - h,209,h);
  }
  function frame(time) {
    raf = 0;
    if (paused || document.hidden) return;
    const dt = last ? Math.min((time - last) / 1000, 0.033) : 1 / 60;
    last = time; step(dt); draw();
    if (!paused && !document.hidden) raf = requestAnimationFrame(frame);
  }
  function act(action) {
    switch (action) {
      case 'raft':
        const follow=crew?.ownsMatt&&!crew.hidden?{...crew.actors.matt,active:true}:rider&&rider.state!=='aboard'?rider.body:raft;
        if(follow?.active){window.scrollTo({top:Math.max(0,follow.y-height*.55),behavior:reduced.matches?'instant':'smooth'});panel.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.focus({preventScroll:true});}
        else announce('Matt and Blackie explore the real edges of the page. Drag them or tap to say hey.');
        return;
      case 'motion':
        toggleMotion(); return;
      case 'flood':
        flooding = !flooding; draining = false; plugOpen=false; paused = false; floodTimer = 0;
        announce(flooding ? 'Bad Timeline. The paint is rising. Pull the plug to drain it.' : 'Flood stopped. The paint will settle.');
        break;
      case 'drain':
        plugOpen=!plugOpen;draining=plugOpen;flooding=false;paused=false;
        if(reduced.matches)plugLift=Number(plugOpen);
        announce(plugOpen?'Plug pulled. The paint is swirling down the drain. Click the stopper to seal it.':'Plug back in. Let it build up again.');
        break;
      case 'pause':
        toys?.cancel();
        villains?.release(true);
        crew?.cancel();
        finishPickup(true);
        if(rider?.state==='drain')rider.rescue();
        if(shake)shake.reset();
        paused = !paused;if(!paused&&plugOpen)draining=true; if(crew?.env)crew.env.paused=paused; announce(paused ? 'Paint and companions paused.' : 'Paint and companions running.');
        break;
      case 'clear':
        toys?.clear();
        villains?.clear();
        crew?.reset();
        finishPickup(true);
        stop(); if(weather){weather.resetShelter();weather.clearStrike();} fluid.clear(); if(tiltFluid)tiltFluid.clear(); if(raft)raft.reset(); if(rider)rider.reset(); if(shake)shake.reset(); drops = []; splashes = []; streaks = []; flooding = draining = plugOpen = false;plugLift=0; paused = true;
        sources.forEach(s => { s.age = 0; }); announce('Clean slate. Paint paused.');
        break;
      case 'bottom':
        window.scrollTo({top:document.documentElement.scrollHeight,behavior:reduced.matches ? 'instant' : 'smooth'});
        return;
    }
    paintButtons(); draw(); if(crew?.env)crew.env.paused=paused; if (paused) stop(); else wake();
  }
  document.querySelectorAll('[data-paint-action]').forEach(button => button.addEventListener('click', () => act(button.dataset.paintAction)));
  if(weatherSelect&&weather)weatherSelect.addEventListener('change',()=>{
    weather.choose(weatherSelect.value);
    announce({auto:'Strange weather rolls in now and then.',paint:'Just the original paint.',rain:'A little Nye weather. Watch the sky.',blood:'Something is watching. Here come the red tears.'}[weatherSelect.value]+(paused?' Resume paint to animate.':''));
    draw();wake();
  });
  toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) { panel.hidden = true; toggle.setAttribute('aria-expanded','false'); toggle.focus(); } });
  mascot.addEventListener('click', () => {
    colorIndex = (colorIndex + 1) % palettes.length; bubble.textContent = palettes[colorIndex].name;
    controls.style.setProperty('--paint-color',palettes[colorIndex].color); spriteReaction = 2.5; spriteFrame = -1;
    const r = mascot.getBoundingClientRect();
    fluid.splash(r.left + r.width / 2, 24);
    if (!paused) for (let i = 0; i < 12; i++) particle(r.left + Math.random() * r.width, r.top + window.scrollY + 80, width*.4, palettes[colorIndex].color, -100);
    announce(palettes[colorIndex].name + (paused ? ' Resume paint for a splash.' : ' Fresh paint in the mix.')); draw();
  });
  sprite.onload = () => { spriteFrame = -1; draw(); };
  new IntersectionObserver(entries => {
    spriteVisible = entries[0].isIntersecting;
    if (spriteVisible) requestSprite();
    if (spriteVisible) drawSprite();
  }, {rootMargin:'100px'}).observe(mascot);
  let resizeFrame = 0;
  const scheduleMeasure = () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(measure); };
  new ResizeObserver(scheduleMeasure).observe(document.body);
  window.addEventListener('resize',scheduleMeasure,{passive:true});
  window.addEventListener('load',scheduleMeasure,{once:true});
  window.addEventListener('scroll',() => { if (paused) draw(); },{passive:true});
  document.addEventListener('visibilitychange',() => { if (document.hidden) {finishPickup(true);if(shake)shake.reset();stop();window.removeEventListener('devicemotion',onMotion);} else {if(motionOn)window.addEventListener('devicemotion',onMotion,{passive:true});wake();} });
  reduced.addEventListener('change',() => { if (reduced.matches) { toys?.cancel();finishPickup(true);disableMotion(); paused = true; stop(); paintButtons(); draw(); announce('Motion paused for your reduced-motion preference.'); } });
  measure(); paintButtons();
  if (paused) announce('Motion is paused. You can start the paint when you want.');
  wake();
})();
